import { LegalUnit } from '../../../../Enums/LegalUnit';

export const canShowAgentAddressInTable = (legalUnitName, agent) => {
  return legalUnitName === LegalUnit.Denmark && !agent.addressIsInherited && agent.address;
};
